(function () {
  var group, nav, wrapper, pinAt = 0, fullH = 0, ticking = false;

  function measure() {
    group.classList.remove('is-stuck');
    group.style.minHeight = '';
    pinAt = Math.max(0, Math.round(nav.getBoundingClientRect().top - group.getBoundingClientRect().top));
    fullH = Math.round(group.getBoundingClientRect().height);
  }
  function update() {
    ticking = false;
    var y = Math.max(wrapper ? wrapper.scrollTop : 0, window.scrollY || 0);
    var stick = y > pinAt;
    if (stick !== group.classList.contains('is-stuck')) {
      if (stick) group.style.minHeight = fullH + 'px';   // keep the page from jumping when the nav leaves the flow
      group.classList.toggle('is-stuck', stick);
      if (!stick) group.style.minHeight = '';
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  function recalc() { var wasStuck = group.classList.contains('is-stuck'); measure(); update(); }

  function init() {
    group = document.getElementById('header-group');
    nav = group && group.querySelector('.ch-nav');
    wrapper = document.querySelector('.page-wrapper');
    if (!group || !nav) return;
    measure(); update();
    window.addEventListener('scroll', onScroll, { passive: true });
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', recalc);
    window.addEventListener('orientationchange', function () { setTimeout(recalc, 250); });
    window.addEventListener('load', recalc);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(recalc);
    group.querySelectorAll('img').forEach(function (i) { if (!i.complete) i.addEventListener('load', recalc); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Back-to-top button (own element on <body>, right side above the chat widget)
  function initBackToTop() {
    if (document.querySelector('.ub-top')) return;
    var w = document.querySelector('.page-wrapper');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'ub-top'; btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 15l-6-6-6 6"/></svg>';
    document.body.appendChild(btn);
    function tog() {
      var y = Math.max(w ? w.scrollTop : 0, window.scrollY || 0, document.body.scrollTop || 0);
      btn.classList.toggle('is-visible', y > 300);
    }
    tog();
    window.addEventListener('scroll', tog, { passive: true });
    document.addEventListener('scroll', tog, { passive: true, capture: true });
    if (w) w.addEventListener('scroll', tog, { passive: true });
    btn.addEventListener('click', function () {
      if (w) w.scrollTo({ top: 0, behavior: 'smooth' });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBackToTop); else initBackToTop();

  // Shop / collection pages: after a filter, sort or page change, jump to where the products start
  function initShopScroll() {
    var layout = document.querySelector('.sp-layout');
    if (!layout) return;
    var w = document.querySelector('.page-wrapper');
    function toProducts(smooth) {
      var target = document.querySelector('.sp-toolbar') || layout;
      var nav = document.querySelector('.ch-nav');
      var navH = nav ? nav.offsetHeight : 64;
      var cur = w ? w.scrollTop : (window.scrollY || 0);
      var y = Math.max(0, Math.round(target.getBoundingClientRect().top + cur - navH - 16));
      var opts = { top: y, behavior: smooth ? 'smooth' : 'auto' };
      if (w) w.scrollTo(opts); else window.scrollTo(opts);
    }
    var flagged = false;
    try { flagged = sessionStorage.getItem('ub-sp-scroll') === '1'; sessionStorage.removeItem('ub-sp-scroll'); } catch (e) {}
    var q = location.search;
    if (flagged || /[?&](filter\.|sort_by=|page=|tag=)/.test(q)) {
      setTimeout(function () { toProducts(false); }, 60);
      window.addEventListener('load', function () { setTimeout(function () { toProducts(false); }, 120); });
    }
    function flag() { try { sessionStorage.setItem('ub-sp-scroll', '1'); } catch (e) {} }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.sp-filters a[href], .sp-results a[href*="page="], .sp-pagination a[href], .sp-sort a[href]');
      if (a && a.getAttribute('href') && a.getAttribute('href').charAt(0) !== '#') flag();
      // client-side author filter changes the grid without reloading
      if (e.target.closest && e.target.closest('.sp-author-filter')) setTimeout(function () { toProducts(true); }, 200);
    });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.sp-sort, .sp-filters')) {
        if (e.target.closest('.sp-author-filter')) setTimeout(function () { toProducts(true); }, 200); else flag();
      }
    });
    document.addEventListener('submit', function (e) { if (e.target.closest && e.target.closest('.sp-sort, .sp-filters')) flag(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShopScroll); else initShopScroll();

  // Shop page: AJAX filter swaps + client-side Author filter -> scroll to products and show an "Author" chip
  function initShopExtras() {
    var region = document.querySelector('.sp-ajax-region');
    if (!region) return;
    var w = document.querySelector('.page-wrapper');
    function toProducts() {
      var target = document.querySelector('.sp-chips--bar') || document.querySelector('.sp-toolbar') || region;
      var nav = document.querySelector('.ch-nav');
      var navH = nav ? nav.offsetHeight : 64;
      var cur = w ? w.scrollTop : (window.scrollY || 0);
      var toolbar = document.querySelector('.sp-toolbar') || target;
      var y = Math.max(0, Math.round(toolbar.getBoundingClientRect().top + cur - navH - 16));
      if (w) w.scrollTo({ top: y, behavior: 'smooth' }); else window.scrollTo({ top: y, behavior: 'smooth' });
    }
    // theme swaps the region's HTML via fetch (and scrolls the wrong element), so scroll after every swap
    if (window.MutationObserver) {
      new MutationObserver(function () {
        try { sessionStorage.removeItem('ub-sp-scroll'); } catch (e) {}
        setTimeout(toProducts, 120);
      }).observe(region, { childList: true });
    }
    var funnel = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M4 5h16l-6 7v6l-4 2v-8L4 5z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
    var xIcon = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
    function authorChip(label) {
      var bar = document.querySelector('.sp-chips--bar');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'sp-chips sp-chips--bar';
        bar.innerHTML = '<span class="sp-chips-label">' + funnel + ' Active filters</span><div class="sp-chips-list"></div><a href="#" class="sp-chips-clear" data-ub-clear>Clear all</a>';
        var layout = document.querySelector('.sp-layout');
        layout.parentNode.insertBefore(bar, layout);
        bar.querySelector('[data-ub-clear]').addEventListener('click', function (e) { e.preventDefault(); location.reload(); });
      }
      var list = bar.querySelector('.sp-chips-list');
      var old = list.querySelector('.sp-chip--author'); if (old) old.remove();
      var chip = document.createElement('a');
      chip.href = '#'; chip.className = 'sp-chip sp-chip--author'; chip.title = 'Remove';
      var em = document.createElement('em'); em.textContent = 'Author';
      var st = document.createElement('strong'); st.textContent = label;
      chip.appendChild(em); chip.appendChild(st); chip.insertAdjacentHTML('beforeend', xIcon);
      chip.addEventListener('click', function (e) { e.preventDefault(); location.reload(); });
      list.appendChild(chip);
    }
    document.addEventListener('click', function (e) {
      var pill = e.target.closest && e.target.closest('.sp-author-filter [data-author-value]');
      if (!pill) return;
      var val = pill.getAttribute('data-author-value');
      if (!val) return;
      var label = '';
      pill.childNodes.forEach(function (n) { if (n.nodeType === 3) label += n.textContent; });
      label = (label || pill.textContent).replace(/\s+/g, ' ').trim();
      setTimeout(function () { authorChip(label); }, 60);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShopExtras); else initShopExtras();

  // Price range slider (two handles) synced with the number inputs; releasing a handle applies the filter
  function initPriceSliders() {
    function bind(root) {
      root.querySelectorAll('.sp-slider:not([data-ub])').forEach(function (sl) {
        sl.setAttribute('data-ub', '1');
        var min = +sl.dataset.min, max = +sl.dataset.max;
        var rMin = sl.querySelector('.sp-range-min'), rMax = sl.querySelector('.sp-range-max');
        var lMin = sl.querySelector('.sp-slider-min-label'), lMax = sl.querySelector('.sp-slider-max-label');
        var fill = sl.querySelector('.sp-slider-fill');
        var form = sl.closest('form');
        var group = sl.parentNode;
        var nMin = group.querySelector('.sp-price-field input[name$=".gte"]') || group.querySelectorAll('.sp-price-field input')[0];
        var nMax = group.querySelector('.sp-price-field input[name$=".lte"]') || group.querySelectorAll('.sp-price-field input')[1];
        var timer;
        function paint() {
          var a = +rMin.value, b = +rMax.value, span = Math.max(1, max - min);
          fill.style.left = ((a - min) / span * 100) + '%';
          fill.style.right = (100 - (b - min) / span * 100) + '%';
          lMin.textContent = a; lMax.textContent = b;
        }
        function sync(which) {
          var a = +rMin.value, b = +rMax.value;
          if (a > b) { if (which === 'min') { rMin.value = b; a = b; } else { rMax.value = a; b = a; } }
          rMin.style.zIndex = a >= max - (max - min) * 0.1 ? 5 : 3; rMax.style.zIndex = 4;
          if (nMin) nMin.value = a > min ? a : '';
          if (nMax) nMax.value = b < max ? b : '';
          paint();
        }
        function apply() {
          clearTimeout(timer);
          timer = setTimeout(function () { if (form && form.requestSubmit) form.requestSubmit(); else if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }, 350);
        }
        rMin.addEventListener('input', function () { sync('min'); });
        rMax.addEventListener('input', function () { sync('max'); });
        rMin.addEventListener('change', apply);
        rMax.addEventListener('change', apply);
        [nMin, nMax].forEach(function (n) {
          if (!n) return;
          n.addEventListener('input', function () {
            var a = nMin && nMin.value !== '' ? +nMin.value : min, b = nMax && nMax.value !== '' ? +nMax.value : max;
            rMin.value = Math.min(Math.max(a, min), max); rMax.value = Math.min(Math.max(b, min), max); paint();
          });
        });
        paint();
      });
    }
    bind(document);
    var region = document.querySelector('.sp-ajax-region');
    if (region && window.MutationObserver) new MutationObserver(function () { bind(document); }).observe(region, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPriceSliders); else initPriceSliders();

  // Author filter combined with the native filters (collection, price, availability).
  // The theme's author filter shows every book by that author in the whole store; here the result is
  // narrowed to the current collection / price range / availability, and the author survives AJAX filter swaps.
  function initAuthorCombine() {
    var region = document.querySelector('.sp-ajax-region');
    if (!region) return;
    var activeAuthor = null, busy = false, cache = {}, lastSig = '';
    function sigOf() { var g = document.querySelector('[id^="shop-grid-"]'); return g ? Array.prototype.map.call(g.querySelectorAll('.shop-product-card'), function (c) { return c.getAttribute('data-product-id'); }).join(',') : ''; }
    function collHandle() { var m = location.pathname.match(/\/collections\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : 'all'; }
    function loadCollection(h) {
      if (cache[h]) return cache[h];
      cache[h] = (async function () {
        var out = [];
        for (var p = 1; p <= 10; p++) {
          var r = await fetch('/collections/' + h + '/products.json?limit=250&page=' + p);
          if (!r.ok) break;
          var j = await r.json(); var b = j.products || [];
          out = out.concat(b);
          if (b.length < 250) break;
        }
        return out;
      })();
      return cache[h];
    }
    function allowedMap(prods) {
      var q = new URLSearchParams(location.search);
      var gte = q.get('filter.v.price.gte'), lte = q.get('filter.v.price.lte'), av = q.get('filter.v.availability');
      var ok = {};
      prods.forEach(function (p) {
        var prices = p.variants.map(function (v) { return parseFloat(v.price); });
        var price = Math.min.apply(null, prices);
        if (gte && price < parseFloat(gte)) return;
        if (lte && price > parseFloat(lte)) return;
        var avail = p.variants.some(function (v) { return v.available; });
        if (av === '1' && !avail) return;
        if (av === '0' && avail) return;
        ok[String(p.id)] = true;
      });
      return ok;
    }
    var countSig = '';
    async function updateCounts() {
      var dataEl = document.querySelector('[id^="sp-author-data-"]');
      var pills = document.querySelectorAll('.sp-author-filter [data-author-value]');
      if (!dataEl || !pills.length) return;
      var sig = location.pathname + location.search + '|' + pills.length;
      if (sig === countSig && document.querySelector('.sp-author-filter .ub-count')) return;
      countSig = sig;
      var data; try { data = JSON.parse(dataEl.textContent.trim()); } catch (e) { return; }
      var prods; try { prods = await loadCollection(collHandle()); } catch (e) { return; }
      var ok = allowedMap(prods);
      document.querySelectorAll('.sp-author-filter [data-author-value]').forEach(function (pill) {
        var id = pill.getAttribute('data-author-value');
        if (!id) return;
        var n = ((data[id] && data[id].products) || []).filter(function (pid) { return ok[String(pid)]; }).length;
        var span = pill.querySelector('.ub-count');
        if (!span) { span = document.createElement('span'); span.className = 'sp-pill-count ub-count'; pill.appendChild(span); }
        span.textContent = n;
        pill.classList.toggle('ub-zero', n === 0);
      });
    }
    async function combine() {
      if (!activeAuthor || busy) return;
      var grid = document.querySelector('[id^="shop-grid-"]');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.shop-product-card'));
      if (!cards.length) return;
      var sig0 = sigOf(); if (sig0 === lastSig) return;
      busy = true;
      try {
        var prods = await loadCollection(collHandle());
        var ok = allowedMap(prods);
        var shown = 0;
        cards.forEach(function (c) { if (ok[c.getAttribute('data-product-id')]) shown++; else c.remove(); });
        var count = document.querySelector('.sp-count');
        if (count) count.textContent = shown + ' book' + (shown === 1 ? '' : 's');
        var empty = document.querySelector('[id^="sp-author-empty-"]');
        if (empty) empty.style.display = shown ? 'none' : 'block';
        grid.style.display = shown ? '' : 'none';
        lastSig = sigOf();
      } catch (e) { console.error(e); }
      busy = false;
    }
    document.addEventListener('click', function (e) {
      var pill = e.target.closest && e.target.closest('.sp-author-filter [data-author-value]');
      if (pill) { activeAuthor = pill.getAttribute('data-author-value') || null; lastSig = ''; }
      if (e.target.closest && e.target.closest('[data-author-reset], .sp-chip--author, [data-ub-clear]')) activeAuthor = null;
    }, true);
    updateCounts();
    if (window.MutationObserver) {
      var countTimer;
      new MutationObserver(function () {
        if (!busy && activeAuthor && sigOf() !== lastSig) combine();
        clearTimeout(countTimer); countTimer = setTimeout(updateCounts, 250);
      }).observe(region, { childList: true, subtree: true });
    }
    // after an AJAX filter swap the theme re-renders the sidebar: re-apply the chosen author
    function reapply() {
      if (!activeAuthor) return;
      var pill = document.querySelector('.sp-author-filter [data-author-value="' + activeAuthor + '"]');
      if (pill && !pill.classList.contains('sp-pill--active')) pill.click();
    }
    var ps = history.pushState;
    history.pushState = function () { var r = ps.apply(this, arguments); setTimeout(reapply, 250); return r; };
    window.addEventListener('popstate', function () { setTimeout(reapply, 400); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAuthorCombine); else initAuthorCombine();
})();
